declare const mxResources: any;

export function getTitleAndUpdatedKeyFromMxResources(key: string): {
  title: string;
  key: string;
} {
  const hasEllipsis = key.endsWith('...');
  const updatedKey = hasEllipsis ? key.slice(0, -3) : key;
  const title = mxResources.get(updatedKey) + (hasEllipsis ? '...' : '');

  return {title, key: updatedKey};
}
